module.exports = __webpack_public_path__ + "img/2.1b179e6.jpg";